{
  "notifications": {
    "modalTitle": "Notification settings",
    "contactDetails": "Your contact details",
    "notificationAbout": "Notification of",
    "email": "E-mail address",
    "phone": "Phone number",
    "saveConfirm": "You are going to save the changes. Do you want to continue?",
    "saveSuccess": "Notification settings have been saved.",
    "selectOrDeselectAll": "Select or deselect all",
    "options": {
      "email": "E-mail",
      "sms": "SMS"
    }
  }
}
